import React from 'react'
// import "./cashFlow.css"
import moment from 'moment'
import { formatIndianCurrency } from '../../helper/ConvertValue';
import { Checkbox } from '@mui/material';

import { motion } from "framer-motion";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";

const CashFlowTable = ({ workspaceDate, data }) => {

    const calculateTotalByIndex = (data, index_1, index_2) => {
        const slicedArray = [...data].slice(index_1, index_2);
        const sumCy = slicedArray.reduce((acc, ele) => acc + (typeof ele.cy === 'number' ? ele.cy : 0), 0);
        const sumPy = slicedArray.reduce((acc, ele) => acc + (typeof ele.py === 'number' ? ele.py : 0), 0);
        return { sumCy, sumPy };
    };

    const calculateCashGeneratedOperatingActivities = () => {
        const workingCaptial = calculateTotalByIndex(data, 0, 17);
        const CashGeneratedOperation = calculateTotalByIndex(data, 17, 27);

        return { cy : (workingCaptial?.sumCy + CashGeneratedOperation?.sumCy), py: (workingCaptial?.sumPy + CashGeneratedOperation?.sumPy) }
    }

    const netCashGeneratedA = () => {
        const cashGeneratedOperatingActivities = calculateCashGeneratedOperatingActivities();
        const income_tax_paid_received = data.find(ele => ele.particular === "Income tax (paid) / refund received")
        return { 
            cy : (cashGeneratedOperatingActivities?.cy + income_tax_paid_received?.cy), 
            py: (cashGeneratedOperatingActivities?.py + income_tax_paid_received?.py)
        }
    }

    const netCashGeneratedABC = () => {
        return { 
            cy : (netCashGeneratedA()?.cy + calculateTotalByIndex(data, 28,55)?.sumCy), 
            py: (netCashGeneratedA()?.py + calculateTotalByIndex(data, 28,55)?.sumPy)
        }
    }

    const CashEquivalentsEndYear = () => {
        const income_tax_paid_received = data.find(ele => ele.particular === "Cash and cash equivalents at the beginning of the year")

        return { 
            cy : (netCashGeneratedABC()?.cy + (typeof income_tax_paid_received?.cy === "number" ? income_tax_paid_received?.cy : 0)), 
            py: (netCashGeneratedABC()?.py + (typeof income_tax_paid_received?.py === "number" ? income_tax_paid_received?.py : 0))
        }
    }

    const calculateBalancesPerStatement = () => 
        data.filter(ele => ["Cash on hand", "Bank balances"].includes(ele?.particular))
        .reduce((acc, sub) => {
            return {
                cy_amt: acc.cy_amt + (typeof sub.cy === "number" ? sub.cy : 0),
                py_amt: acc.py_amt + (typeof sub.py === "number" ? sub.py : 0),
            };
        }, { cy_amt: 0, py_amt: 0 })

    // common table header; we only replace the first <th> label
    const renderThead = (title) => (
        <thead>
            <tr>
                <th className='text-left pl-3  custom-font-600  -0 text-uppercase font-inter'
                    style={{ fontSize: "15px", width: "30%" ,
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E"}} >
                    {title}
                </th>
                <th className='text-center custom-font-600  -0 text-uppercase font-inter'
                    style={{ fontSize: "15px", width: "10%",
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E" }}>Notes</th>
                <th className='text-right   -0' style={{width: "15%",
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E"}}>
                        Year ended {moment(workspaceDate?.cy).format("DD MMMM YYYY")}
                </th>
                <th className='text-right   -0' style={{width: "19%",
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E"}}>
                        Year ended {moment(workspaceDate?.py).format("DD MMMM YYYY")}
                </th>
                <th className='text-center   -0' style={{width: "10%",
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E"}}>REFERENCES
                </th>
                <th className='text-center pr-3   -0' style={{width: "10%",
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E"}}>IND AS REFERENCES
                </th>
                <th className='text-center pr-3   -0' style={{
                      padding: "8px",
                      // minWidth: "6rem",
                      backgroundColor: '#EFF7F0',
                      color: "#33584E"}}>CHECKLIST REFERENCES
                </th>
            </tr>
        </thead>
    );

    const tables = [];
    let rows = [];
    // initial header text replaces the very first yellow row that we are removing
    let currentTitle = "Cash flow from operating activities";

    for (let i = 0; i < (data?.length || 0); i++) {
        const ele = data[i];

        // === keep original totals row block ===
        if ([17,28,34,55,56].includes(i)) {
            rows.push(
                <tr key={`sum-${i}`}>
                    <td className='font-weight-bold'>
                        {i === 28 && "Net cash generated / (used) in operating activities (A)"}
                        {i === 34 && "Net cash used in investing activities (B)"}
                        {i === 55 && "Net cash from financing activities (C)"}
                        {i === 56 && "Cash and cash equivalents at the end of the year "}
                    </td>
                    <td></td>
                    <td className={`font-weight-bold  text-right pr-3 ${[28,34,55,56].includes(i) && ""}`}>
                        {i === 17 && formatIndianCurrency(calculateTotalByIndex(data, 0, 17)?.sumCy, null, true)}
                        {i === 28 && formatIndianCurrency(netCashGeneratedA()?.cy, null , true)}
                        {i === 34 && formatIndianCurrency(calculateTotalByIndex(data, 28,34)?.sumCy, null, true)}
                        {i === 55 && formatIndianCurrency(calculateTotalByIndex(data, 34, 55)?.sumCy, null, true)}
                        {i === 56 && formatIndianCurrency(CashEquivalentsEndYear()?.cy, null , true)}
                    </td>
                    <td className={`font-weight-bold  text-right pr-3 ${[28,34,55,56].includes(i) && ""}`}>
                        {i === 17 && formatIndianCurrency(calculateTotalByIndex(data, 0, 17)?.sumPy, null, true )}
                        {i === 28 && formatIndianCurrency(netCashGeneratedA()?.py, null, true )}
                        {i === 34 && formatIndianCurrency(calculateTotalByIndex(data, 28,34)?.sumPy, null, true )}
                        {i === 55 && formatIndianCurrency(calculateTotalByIndex(data, 34, 55)?.sumPy, null, true )}
                        {i === 56 && formatIndianCurrency(CashEquivalentsEndYear()?.py, null, true )}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            );
        }

        // === split tables exactly at the yellow rows (i === 28 and i === 34) ===
        if (i === 28 || i === 34) {
            // close current table BEFORE the yellow row (we already pushed the totals row above)
            tables.push(
                <motion.div
              // className="tableSheet"
              // className={`${bookclosuretablecss.bookClosureTableContainer} m-3`}
              initial={{ y: "-5vh" }}
              animate={{ y: 0 }}
              className="m-2 mx-3" key={`table-up-to-${i}`}>
                    <table className={`${bookclosuretablecss.bookClosureTable} ${tablecss.brTable}`}>
                        {renderThead(currentTitle)}
                        <tbody>{rows}</tbody>
                    </table>
                </motion.div>
            );
            rows = [];
            // update header for next section (replacing the yellow row text)
            if (i === 28) currentTitle = "Cash flows from investing activities";
            if (i === 34) currentTitle = "Cash flows from financing activities";
        } else {
            // === keep the second special row EXACTLY (but naturally this won't run for 28 or 34 since we handled split above) ===
            if ([17,28,34,55,56].includes(i)) {
                rows.push(
                    <tr key={`sec-${i}`}>
                        <td className="font-weight-bold" style={{backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent"}}>
                            {i === 17 && "Working capital adjustments:"}
                            {i === 28 && "Cash flows from investing activities"}
                            {i === 34 && "Cash flows from financing activities"}
                            {i === 55 && "Net (decrease) in cash and cash equivalents (A+B+C)"}
                            {i === 56 && "Reconciliation of cash and cash equivalents as per cash flow statement"}
                        </td>
                        <td style={{backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent"}}></td>
                        <td className="font-weight-bold text-right pr-3" style={{ backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent"}}>
                            {i === 55 && formatIndianCurrency(netCashGeneratedABC()?.cy, null, true)}
                        </td>
                        <td className="font-weight-bold text-right pr-3" style={{ backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent" }}>
                            {i === 55 && formatIndianCurrency(netCashGeneratedABC()?.py, null, true)}
                        </td>
                        <td style={{ backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent" }}></td>
                        <td style={{backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent"}}></td>
                        <td style={{backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent"}}></td>
                        <td style={{backgroundColor: i === 28 || i === 34 ? "#f2e2b5" : "transparent"}}></td>
                    </tr>
                );

                if (i === 56) {
                    rows.push(
                        <tr key="cce-breaker">
                            <td>{"Cash and cash equivalents as per the above comprises of the following"}</td>
                            <td></td><td></td><td></td><td></td><td></td><td></td>
                        </tr>,
                        <tr key="as-at-labels">
                            <td></td><td></td>
                            <td className='text-right pr-3'>
                                <p className='m-0 font-weight-bold' style={{ fontSize: "14px", fontWeight: "600" }} >As at </p>
                                <p className='m-0 font-weight-bold' style={{ fontSize: "14px", fontWeight: "600" }} >{moment(workspaceDate?.cy).format("DD MMMM YYYY")}</p>
                            </td>
                            <td className='text-right pr-3'>
                                <p className='m-0 font-weight-bold' style={{ fontSize: "14px", fontWeight: "600" }} >As at </p>
                                <p className='m-0 font-weight-bold' style={{ fontSize: "14px", fontWeight: "600" }} >{moment(workspaceDate?.py).format("DD MMMM YYYY")}</p>
                            </td>
                            <td></td><td></td><td></td>
                        </tr>
                    );
                }
            }
        }

        // === keep original [1, 27] block EXACTLY ===
        if ([1, 27].includes(i)) {
            rows.push(
                <tr key={`adj-${i}`}>
                    <td className='font-weight-bold'>
                        {i === 1 && "Adjustments:"}
                        {i === 27 && "Cash generated from operating activities"}
                    </td>
                    <td></td>
                    <td className={`font-weight-bold text-right pr-3 ${i === 27 && ""}`}>{i === 27 && formatIndianCurrency(calculateCashGeneratedOperatingActivities()?.cy, null, true)}</td>
                    <td className={`font-weight-bold text-right pr-3 ${i === 27 && ""}`}>{i === 27 && formatIndianCurrency(calculateCashGeneratedOperatingActivities()?.py, null, true)}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            );
        }

        // === main data row (unchanged) ===
        rows.push(
            <tr key={i}>
                <td>{ele?.particular}</td>
                <td className='text-right pr-3' >{ele?.note}</td>
                <td className='text-right pr-3' >{formatIndianCurrency(ele?.cy, null, true)}</td>
                <td className='text-right pr-3' >{formatIndianCurrency(ele?.py, null, true)}</td>
                <td></td>
                <td className='text-center'>
                    <input type="radio" />
                </td>
                <td className='text-center'>
                    <input type="radio" />
                </td>
            </tr>
        );
    }

    // final balances row stays in the last table
    rows.push(
        <tr key="balances-final">
            <td className='font-weight-bold'>Balances as per statement of cash flows</td>
            <td></td>
            <td  className='font-weight-bold   text-right pr-3'>{formatIndianCurrency(calculateBalancesPerStatement()?.cy_amt, null, true)}</td>
            <td  className='font-weight-bold   text-right pr-3'>{formatIndianCurrency(calculateBalancesPerStatement()?.py_amt, null, true)}</td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
    );

    // push the last table
    tables.push(
        <motion.div
              // className="tableSheet"
              // className={`${bookclosuretablecss.bookClosureTableContainer} m-3`}
              initial={{ y: "-5vh" }}
              animate={{ y: 0 }}
              className="m-2 mx-3" key={`table-final`}>
            <table className={`${bookclosuretablecss.bookClosureTable} ${tablecss.brTable}`}>
                {renderThead(currentTitle)}
                <tbody>{rows}</tbody>
            </table>
        </motion.div>
    );

    return <>{tables}</>;
}

export default CashFlowTable
